import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { AxiosError } from 'axios';

export const parseErrorMessage = (error: Record<string, any>) => {
    if (error?.response?.data?.error?.length) {
        return error.response.data.error[0];
    } else {
        return 'Unknown error';
    }
};

export const isAxiosError = (error: unknown): error is AxiosError => {
    return !!error && (error as AxiosError).response !== undefined;
};

export const parseApiErrorMessage = (error: FetchBaseQueryError | SerializedError | undefined) => {
    if (!error) {
        return undefined;
    }

    if ('status' in error) {
        // you can access all properties of `FetchBaseQueryError` here
        const errMsg = 'error' in error ? error.error : JSON.stringify(error.data);

        return errMsg;
    } else {
        // you can access all properties of `SerializedError` here
        return error.message;
    }
};
